import { BrowserModule } from '@angular/platform-browser';
import {
  APP_INITIALIZER,
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RequestInterceptor } from './service/request-interceptor.service';
import { DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SelectDeliveryTypeModule } from './cards/select-delivery-type/select-delivery-type.module';
import { PopupModule } from './popup/popup.module';
import { RecomendationsModule } from './recomendations/recomendations.module';
import { InquiryPopupModule } from './store/inquiry-popup/inquiry-popup.module';
import { SearchModule } from './search/search.module';
import { HeaderModule } from './header/header.module';
import { FooterModule } from './footer/footer.module';
import { AllergensFooterModule } from './allergens-footer/allergens-footer.module';
import { BottomMenuModule } from './bottom-menu/bottom-menu.module';
import { WelcomeMessageModule } from './welcome-message/welcome-message.module';
import { ConnectionCheckModule } from './connection-check/connection-check.module';
import { ProgressComponent } from './progress/progress.component';
import { AnalyticsModule } from './analytics/analytics.module';
import { NewHeaderModule } from './new-header/new-header.module';
import { LazyComponentModule } from './shared/lazy-component';
import { resolveBrand } from './brand/brand-context';

@NgModule({
  declarations: [AppComponent, ProgressComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    SelectDeliveryTypeModule,
    PopupModule,
    RecomendationsModule,
    InquiryPopupModule,
    SearchModule,
    HeaderModule,
    NewHeaderModule,
    FooterModule,
    AllergensFooterModule,
    BottomMenuModule,
    WelcomeMessageModule,
    ConnectionCheckModule,
    AnalyticsModule,
    LazyComponentModule,
  ],
  providers: [
    AppComponent,
    // which brand this page is for (URL path, else the host name) - before
    // the router, the interceptor or storage namespacing need it
    { provide: APP_INITIALIZER, useFactory: () => resolveBrand, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true,
    },
    DatePipe,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
